export const environment = {
   production: true,
   baseUrl: 'https://loyalty-api-dev.vasrefil.com'
};
